module.exports = __webpack_public_path__ + "static/media/bell-school-slash.704cac68.svg";